import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'

import './App.css';
import MainSignin from './main/Signin'
import DataToolSignin from './datatool/Signin'

// Note: for Heroku desployments, add static.json file as referenced here: https://stackoverflow.com/questions/41772411/react-routing-works-in-local-machine-but-not-heroku

const Main = () => (
  <div>
    <MainSignin></MainSignin>
  </div>
)

const DataTool = () => (
  <div>
    <DataToolSignin></DataToolSignin>
  </div>
)
  
const BasicExample = () => (
  <Router>
    <div>
      <Route exact path="/" component={Main}/>
      <Route path="/DataTool" component={DataTool}/>
    </div>
  </Router>
)

export default BasicExample


// WEBPACK FOOTER //
// ./src/App.js